import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InventoryFilter from './inventory-filter';
import InventoryTable from './inventory-table';
import InventoryTile from './inventory-tile';
import InventorySearch from './inventory-search';
import InventoryDetailModal from './inventory-detail-modal';
import { selectInventoryFilterVisible, selectInventoryFilters, selectTileView } from './store/selectors';
import { actions as inventoryActions, fetchInventoriesWithFilters } from './store/slice';

const { setClassFilters } = inventoryActions;

const InventoryContent = props => {
  const dispatch = useDispatch();
  const isFilterVisible = useSelector(selectInventoryFilterVisible);
  const showTileView = useSelector(selectTileView);
  const { serialNumber } = useSelector(selectInventoryFilters);

  const [selectedType, setSelectedType] = useState('FG');
  
  // Modal state
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  
  const handleTypeChange = (type) => {
    setSelectedType(type);

    const classFilters = {
      FG: type === 'FG',
      PL: type === 'PL',
      IN: type === 'IN',
      Others: type === 'Others',
    };

    dispatch(setClassFilters(classFilters));
    dispatch(fetchInventoriesWithFilters());
  };

  const handleOpenDetailModal = (inventoryData) => {
    setSelectedInventory(inventoryData);
    setShowDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedInventory(null);
  };

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <InventorySearch selectedType={selectedType} handleTypeChange={handleTypeChange} />
        </div>
        {isFilterVisible && <InventoryFilter />}

        {!showTileView ? (
          <InventoryTable 
            selectedType={selectedType} 
            onOpenDetailModal={handleOpenDetailModal}
          />
        ) : (
          <InventoryTile 
            selectedType={selectedType} 
            onOpenDetailModal={handleOpenDetailModal}
          />
        )}
      </div>
      
      {/* Inventory Detail Modal */}
      <InventoryDetailModal
        show={showDetailModal}
        onHide={handleCloseDetailModal}
        inventoryData={selectedInventory}
        highlightSerialNumber={serialNumber}
      />
    </div>
  );
};

export default InventoryContent;
